import { render, staticRenderFns } from "./wexinAuthorization.vue?vue&type=template&id=bce10540&"
import script from "./wexinAuthorization.vue?vue&type=script&lang=js&"
export * from "./wexinAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports